type EventName = "touches" | "categories" | "dishes" | "interactiveSeconds" | "automaticReturns" | "imageErrors";
type DailyStats = Record<EventName, number>;

const key = "osen-kiosk-analytics-v1";
const empty = (): DailyStats => ({ touches: 0, categories: 0, dishes: 0, interactiveSeconds: 0, automaticReturns: 0, imageErrors: 0 });

export function track(event: EventName, amount = 1): void {
  try {
    const today = new Date().toISOString().slice(0, 10);
    const stored = JSON.parse(localStorage.getItem(key) ?? "{}") as Record<string, DailyStats>;
    stored[today] = stored[today] ?? empty();
    stored[today]![event] += amount;
    const trimmed = Object.fromEntries(Object.entries(stored).sort(([a], [b]) => b.localeCompare(a)).slice(0, 30));
    localStorage.setItem(key, JSON.stringify(trimmed));
  } catch { /* Kiosk operation must continue when storage is unavailable. */ }
}
